<!--
  顶部组件
-->
<template>
  <div class="top_head">
    <img class="back_img" src="../assets/img/top_img.png" />
    <div class="top_left">
      <div class="content">
        <span class="text">{{ dateTime.date }}</span>
        <div class="text">
          {{ dateTime.week }}
        </div>
        <span class="time">
          {{ dateTime.time }}
        </span>
      </div>
    </div>

    <div class="top_middle">木棉树污水处理厂大数据平台</div>

    <div class="top-r">
      <div class="content">
        <!-- <span class="">天气</span> -->
        <div class="blue weather">
          <!-- <div class="text">{{weather.wea}}</div> -->
          <div class="text">晴</div>
          <div class="text">
            <!-- <img :src="require(`../assets/weatherImg/${weather.wea_img}.png`)"/> -->
            <img :src="require(`../assets/weatherImg/qing.png`)"/>
          </div>
          <div>32℃</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: "TopHead",
  data() {
    return {
      // 日期时间
      dateTime: {
        week: "", // 周几
        time: "", // 时间
        PorA: "", // AM还是PM
        date: "", // 日期
      },
      // 天气数据
      weather:{
        wea:'晴',
        tem:'25',
        wea_img:"yin"
      }
    };
  },
  mounted() {
    setInterval(() => {
      this.setDateTime();
    }, 1000);
    this.setWeather()
    // 天气数据1小时更新一次
    setInterval(()=>{
      this.setWeather()
    },60*60*1000)
  },
  methods: {
    // 获取时间
    setDateTime() {
      let date = new Date();
      let week = ["周日", "周一", "周二", "周三", "周四", "周五", "周六"];
      let time = `${date.getHours()}:${date.getMinutes()}:${
        date.getSeconds() > 10 ? date.getSeconds() : "0" + date.getSeconds()
      }`;
      let nowDate = `${date.getFullYear()}/${date.getMonth() + 1}/${
        date.getDate() >= 10 ? date.getDate() : "0" + date.getDate()
      }`;

      this.dateTime = {
        week: week[date.getDay()],
        time: time,
        date: nowDate,
      };
    },
    // 获取天气
    setWeather(){
      axios.get('https://www.yiketianqi.com/free/day',{params:{appid:'98673353',appsecret:'rJh6i01h',unescape:'1',city:'宜宾'}})
        .then(res=>{
          if(res.status == 200){
            this.weather = {...res.data}
          }
        })
    }
  },
};
</script>

<style lang="less" scoped>
.top_head {
  color: #fff;
  font-size: 36px;
  font-family: PMZ;
  width: 5760px;
  height: 516 * @vh;
  background-image: url("../assets/img/top_back.png");
  background-size: 100% 100%;
  display: flex;
  justify-content: space-between;
  position: fixed;
  top: 0;
  z-index: 1;
  // 背景图
  .back_img {
    width: 5760px;
    height: 359vh * @vh;
    position: absolute;
    z-index: -1;
  }
  & > div {
    margin-top: 35vh * @vh;
    font-size: 56px;
  }
  // 添加分隔线
  .text {
    display: flex;
    align-items: center;
    white-space: nowrap;
    &::after {
      margin: 0 24px;
      content: "";
      display: block;
      width: 220px;
      height: 16vh * @vh;
      background-image: url("../assets/img/top_line.png");
      background-size: 100% 100%;
    }
  }
  .top_left {
    width: 1910px;
    height: 118vh * @vh;
    background-size: cover;
    position: relative;
    .content {
      width: 1263px;
      position: absolute;
      left: 400px;
      display: flex;
    }
    .time {
      overflow: hidden;
      span {
        float: right;
      }
    }
  }
  .top_middle {
    width: 2027px;
    height: 153vh * @vh;
    background-size: cover;
    text-align: center;
    font-size: 116px;
    text-shadow: 0 0 29px rgba(0, 143, 255, 0.66);
    margin-top: 38vh * @vh;
  }
  .top-r {
    width: 1910px;
    height: 118vh * @vh;
    position: relative;
    img {
      width: 100%;
      height: 100%;
      transform: scaleX(-1);
      // position: absolute;
      float: left;
    }
    .content {
      width: 540px;
      position: absolute;
      left: 240px;
      display: flex;
      justify-content: space-between;
      .weather {
        display: flex;
        width: 305px;
        justify-content: space-between;
        align-items: center;
        img {
          width: 80px;
        }
      }
    }
  }
}

@media screen and (min-width: 3640px),screen and(max-height: 1080) {
  .top_head {
    div{
      font-size: 32px;
    }
    .weather {
        img {
          width: 40px !important;
        }
      }
      .top_middle {
        width: 2027px;
        height: 153vh * @vh;
        font-size: 80px;
        margin-top: 12vh * @vh;
      }
  }
}
</style>
